declare const CHECKOUT_BASE_URL: string;

export const ENDPOINTS = {
  authenticate: `${CHECKOUT_BASE_URL}/v1/authenticate`,
  form: `${CHECKOUT_BASE_URL}/v1/form`,
  fetchSession: `${CHECKOUT_BASE_URL}/v1/sessions`,
  paymentInstructionsForm: `${CHECKOUT_BASE_URL}/v1/payments/:paymentReference/payment_instructions/form`,
  documentCollectionForm: `${CHECKOUT_BASE_URL}/v1/document_collections/form`,
  lrsForm: `${CHECKOUT_BASE_URL}/v1/lrs/form`,
  paymentMethodSelectorForm: `${CHECKOUT_BASE_URL}/v1/payment_method_selector/form`,
  recipientFieldsForm: `${CHECKOUT_BASE_URL}/v1/recipient_fields/form`
};
